import { Operators } from "../enums/Operator.enum";
import { CustomQuery } from "../models/CustomQuery";

export const NB_LIST_VALUE: number = 400;
export const DefaultQuery: CustomQuery = {code : '',critereName : '', operator : Operators.EQUALS, value : ''};
